<template>
  <loader v-if="computedLoading" />

  <alert v-if="computedError" :message="computedError" :variant="'error'" />

  <advice
    v-if="computedAdviceSlip"
    :photographer="computedAdviceSlip?.photo?.author?.name"
    :advice="computedAdviceSlip?.advice?.text"
    :imageSrc="computedAdviceSlip?.photo?.url"
    :imageAlt="computedAdviceSlip?.photo?.alt"
  />
</template>

<script>
import Advice from "@/components/Modules/Advice";
// import Loader from "@/components/Modules/Loader";
import getAdviceSlip from "../components/mixins/getAdviceSlip";
import Loader from "../components/Modules/Loader.vue";
import Alert from "../components/Modules/Alert.vue";

export default {
  name: "Home",
  mixins: [getAdviceSlip],
  components: { Advice, Loader, Alert },
};
</script>
